<template>
    <yams-template>
        <template #header>
            <div class="mr-5">
                <h4 class="text-primary font-weight-bold">Courses ({{ lines }})</h4>
            </div>
            <div class="mr-4">
                <NavOperations></NavOperations>
            </div>
            <div class="btn-group page-nav mr-4" role="group" aria-label="Basic example">
                <button type="button" class="btn " @click.prevent="changeAffichage('table')"
                    :class="{ 'active': affichage === 'table' }">
                    <i class="fa-solid fa-bars"></i>
                </button>
                <button type="button" class="btn " @click.prevent="changeAffichage('card')"
                    :class="{ 'active': affichage === 'card' }">
                    <i class="fa-solid fa-border-all"></i>
                </button>
            </div>
            <div class="px-1">
                <button type="button" class="btn-yams btn-active" @click="openCreateModal()">
                    Ajouter une course <i class="fa-solid fa-plus"></i>
                </button>
            </div>
        </template>
        <template #content>
            <div class="card mb-3">
                <div class="card-body p-2">
                    <FilterCustom :selectOptions="filterSelectOptions" :baseUrl="baseURL" :hasDateFilter="true"
                        :existingSelectors="['vehicule', 'client', 'chauffeur', 'proprietaire', 'reglement']"
                        :defaultValues="defaultFilterValues" @filter-applied="onFilterApplied"
                        @filter-reset="onFilterReset" @get-existing-selectors="getExistingSelectorsParams"
                        @reset-existing-selectors="resetExistingSelectors">

                        <template #existing-selectors>
                            <div class="filter-select-wrapper">
                                <label>Propriétaire</label>
                                <select class="form-control" v-model="selectedValues.proprietaire"
                                    @change="updateFilters">
                                    <option value="">Tous les propriétaires</option>
                                    <option v-for="proprietaire in proprietaires" :key="proprietaire.id"
                                        :value="proprietaire.id">
                                        {{ proprietaire.nom_complet }}
                                    </option>
                                </select>
                            </div>

                            <div class="filter-select-wrapper">
                                <label>Vehicule</label>
                                <SelectVehicule :creation="false" :key="'vehicule-' + componentKeys.vehicule"
                                    :line="selectedValues.vehicule"
                                    @set-selected="(value, object) => onSelectChange('vehicule', value, object)" />
                            </div>

                            <div class="filter-select-wrapper">
                                <label>Client</label>
                                <SelectClient :creation="false" :key="'client-' + componentKeys.client" :line="selectedValues.client"
                                    @set-selected="(value, object) => onSelectChange('client', value, object)" />
                            </div>

                            <div class="filter-select-wrapper">
                                <label>Chauffeur</label>
                                <select class="form-control" v-model="selectedValues.chauffeur" @change="updateFilters">
                                    <option value="">Tous les chauffeurs</option>
                                    <option v-for="chauffeur in chauffeurs" :key="chauffeur.id" :value="chauffeur.id">
                                        {{ chauffeur.nom_complet }}
                                    </option>
                                </select>
                            </div>
                        </template>
                    </FilterCustom>
                </div>
            </div>

            <div class="card mb-5">
                <div class="card-body p-1">
                    <DataTableBackend :key="key" :url="url" :view-mode="affichage" :columns="columns" :table="table"
                         v-on:set-total-records="updateLines" @row-click="openShowModal"
                        @set-selected-rows="getSelection">
                        <template #course_details=slotProps>
                            <span class="bg-secondary p-1 rounded text-white text-center">{{
                                slotProps.data.course_details }}</span>
                        </template>
                        <template #statut=slotProps>
                            <span class="p-2 rounded-pill badge" :class="{
                                'badge-secondary': slotProps.data.statut === 'Chargement en attente',
                                'badge-primary': slotProps.data.statut === 'Transport en cours',
                                'badge-success': slotProps.data.statut === 'Terminé',
                                'badge-danger': slotProps.data.statut === 'Problemes mécaniques',
                                'badge-info': slotProps.data.statut === 'Chargement terminé'
                            }">
                                {{ slotProps.data.statut }}
                            </span>

                        </template>
                    </DataTableBackend>
                </div>
            </div>
        </template>

    </yams-template>
</template>

<script>
import { defineComponent, defineAsyncComponent } from 'vue';
import NavOperations from '../NavOperations.vue';
import FilterCustom from '@/components/FilterCustom.vue';

const FormCourse = defineAsyncComponent(() => import('@/views/operations/courses/FormCourse.vue'));
const ShowCourse = defineAsyncComponent(() => import('@/views/operations/courses/ShowCourse.vue'));
const SelectVehicule = defineAsyncComponent(() => import('@/views/parc-auto/vehicules/SelectVehicule.vue'));
const SelectClient = defineAsyncComponent(() => import('@/views/operations/clients/SelectClient.vue'));

export default defineComponent({
    name: 'IndexCourse',
    components: { NavOperations, FilterCustom, SelectVehicule, SelectClient },
    data() {
        return {
            key: 1,
            lines: 0,
            filterOpen: false,
            baseURL: this.$store.getters.apiUrl + '/api/courses',
            url: this.$store.getters.apiUrl + '/api/courses',
            affichage: "table",
            selection: [],
            table: 'courses',

            proprietaires: [],
            chauffeurs: [],
            componentKeys: {
                vehicule: 1,
                client: 1,
            },
            selectedValues: {
                vehicule: '',
                client: '',
                chauffeur: '',
                proprietaire: '',
                reglement: ''
            },
            selectedObjects: {
                vehicule: null,
                client: null,
            },
            defaultFilterValues: {
            },
            filterSelectOptions: [
                {
                    name: 'reglement',
                    label: 'Règlement',
                    placeholder: 'Tous les règlements',
                    options: [
                        { value: 'Payé', label: 'Payé' },
                        { value: 'Non payé', label: 'Non payé' },
                        { value: 'Acompte', label: 'Acompte' }
                    ]
                }
            ],

            columns: [
                {
                    key: 'code',
                    label: 'Code',
                    exportable: true,
                    sortable: true
                },
                {
                    key: 'vehicule.plaque',
                    label: 'Vehicule',
                    exportable: true,
                    sortable: true
                },
                {
                    key: 'client_nom_complet',
                    label: 'Client',
                    exportable: true,
                    sortable: true
                },
                {
                    key: 'type_course',
                    label: 'Type',
                    exportable: true,
                    sortable: true
                },
                {
                    key: 'course_details',
                    class: 'bg-secondary p-1 rounded text-white text-center',
                    label: 'Trajet',
                    exportable: true
                },
                {
                    key: 'montant',
                    label: 'Montant',
                    format: 'money',
                    exportable: true
                },
                {
                    key: 'etat',
                    label: 'Reglement',
                },
                {
                    key: 'statut',
                    label: 'Statut',
                },
            ],
            selectedVehicule: null,
        };
    },
    mounted() {
        this.fetchProprietaires();
        this.fetchChauffeurs();
    },
    methods: {
        fetchProprietaires() {
            const url = `${this.$store.getters.apiUrl}/api/utilisateurs?type=transporteur`;
            fetch(url)
                .then(response => response.json())
                .then(data => {
                    this.proprietaires = data.data || [];
                })
                .catch(error => {
                    console.error('Erreur lors du chargement des propriétaires:', error);
                });
        },

        fetchChauffeurs() {
            const url = `${this.$store.getters.apiUrl}/api/utilisateurs?type=transporteur`;
            fetch(url)
                .then(response => response.json())
                .then(data => {
                    this.chauffeurs = data.data || [];
                })
                .catch(error => {
                    console.error('Erreur lors du chargement des chauffeurs:', error);
                });
        },

        onSelectChange(field, value, object = null) {
            this.selectedValues[field] = value;
            if (object) {
                this.selectedObjects[field] = object;
            }
            this.updateFilters();
        },

        updateFilters() {
        },

        onFilterApplied(filteredUrl) {
            this.url = filteredUrl;
            this.key++;
        },

        onFilterReset(baseUrl) {
            this.url = baseUrl;
            this.key++;
        },

        getExistingSelectorsParams(callback) {
            const existingParams = {};
            Object.keys(this.selectedValues).forEach(key => {
                if (this.selectedValues[key]) {
                    existingParams[key] = this.selectedValues[key];
                }
            });
            callback(existingParams);
        },

        resetExistingSelectors() {
            Object.keys(this.selectedValues).forEach(key => {
                this.selectedValues[key] = '';
            });
            Object.keys(this.selectedObjects || {}).forEach(key => {
                this.selectedObjects[key] = null;
            });
            Object.keys(this.componentKeys).forEach(key => {
                this.componentKeys[key]++;
            });
        },

        openShowModal(objData) {
            this.$dialog.open(ShowCourse, {
                props: {
                    header: "Course " + objData.code,
                    style: {
                        width: '50vw'
                    },
                    modal: true
                },
                data: objData
            });
        },
        openCreateModal() {
            this.$dialog.open(FormCourse, {
                props: {
                    header: "Nouvelle course",
                    style: {
                        width: '50vw'
                    },
                    modal: true
                }
            });
        },
        changeAffichage(type) {
            this.affichage = type;
            this.key++
        },
        getSelection(selection) {
            this.selection = selection
        },
        updateLines(nb_lines) {
            this.lines = nb_lines
        },

        onVehiculeChanged(vehicule) {
            console.log('Véhicule sélectionné:', vehicule);
            this.selectedVehicule = vehicule;
        },
    }
});
</script>

<style scoped>
.filter-select-wrapper {
    min-width: 200px;
    margin-bottom: 10px;
}

:deep(.card-body) {
    flex: none !important;
}
</style>